<template>
  <div class="main-right">
    <div class="header">重心转移</div>
    <div class="block-body">
      <div class="body-top">
        <p class="body-title">{{title}}发展重心转移图</p>
        <div class="map">
          <div id="container" style="height: 100%"></div>
        </div>
        <div class="year">
          <div class="btns-box">
            <div
              v-for="(item, key) in 14"
              class="drop"
              :class="{ active: activeIndex == key }"
              @click="
                activeIndex = key;
                changeMarker(key);
              "
            >
              <span></span>
            </div>
          </div>
          <ul class="check-box">
            <li
              v-for="item in yearList"
              :key="item.key"
              :class="{ active: activeIndex == item.key }"
            >
              {{ item.val }}
            </li>
          </ul>
        </div>
      </div>
      <div class="body-bottom">
        <p class="body-title">{{title}}发展重心转移方向及距离</p>
        <!-- <a-table
          :data-source="data"
          :columns="columns"
          :pagination="false"
        ></a-table> -->
        <div style="width: 100%">
          <table class="table">
            <tr
              v-for="(item, key) in tabData"
              :key="key"
              :class="{ active: activeIndex == key && key != 0 }"
            >
              <td v-for="(i, k) in item" :class="{'tab-weight':key == 0}" :key="k" v-html="i"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

// 高德地图 2.0 安全密钥兜底（main.js 已设置，这里再保一次，防止单页跳入时未设置）
if (!window._AMapSecurityConfig) {
  window._AMapSecurityConfig = {
    securityJsCode: "a6c95f2d49553768ccd84ab100783147",
  };
}
const data = [
  {
    key: "1",
    city: "北京",
    fz: "0.1223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "2",
    city: "上海",
    fz: "0.2223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "3",
    city: "广东",
    fz: "0.3223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
];
const columns = [
  {
    title: "序号",
    dataIndex: "key",
    key: "key",
    width: 80,
  },
  {
    title: "指标名称",
    dataIndex: "city",
    key: "city",
    width: 100,
  },
  {
    title: "2010年",
    dataIndex: "fz",
    key: "fz",
  },
  {
    title: "2010年",
    dataIndex: "jj",
    key: "jj",
  },
  {
    title: "2010年",
    dataIndex: "sh",
    key: "sh",
  },
  {
    title: "2010年",
    dataIndex: "hj",
    key: "hj",
  },
  {
    title: "2010年",
    dataIndex: "gn",
    key: "gn",
  },
  {
    title: "2010年",
    dataIndex: "cx",
    key: "cx",
  },
];
let timer ,infoWindow
export default {
  props: ["cubeId",'title'],
  data() {
    return {
      data,
      columns,
      AMap: null,
      tabData: [],
      yearList: [],
      activeIndex: 0,
      focusData: [],
      markerList: [],

    };
  },

  mounted() {
    this.getIndicatorTrend();
    this.initMap();
    timer = setInterval(() => {
      if (this.activeIndex < 13) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
      this.changeMarker(this.activeIndex);
    }, 1500);
  },

  methods: {
    markerHandler(e){
      const extData = e.target.getExtData()
      const itemFocus = this.focusData.find(item=>item.years == extData)
      const innerhtml = `
        <div className="custom-infowindow input-card">
          <label style="color:grey">当前位置及年份</label>
          <div class='input-item'>${itemFocus.years}<div>
          <div class='input-item'>东经:${itemFocus.longitude}<div>
          <div class='input-item'>北纬:${itemFocus.latitude}<div>
        <div>
      `
      infoWindow.setContent(innerhtml)
      infoWindow.open(this.map,e.target.getPosition())

      setTimeout(()=>{
        infoWindow.close()
      },3000)
    },
    changeMarker(count) {
      if (!this.AMap) return;
      const Icon = new this.AMap.Icon({
        size: new this.AMap.Size(30, 30),
        image: require("@/assets/dw.png"),
        imageSize: new this.AMap.Size(30, 30),
        imageOffset: new this.AMap.Pixel(0, 0),
      });
      const smallIcon = new this.AMap.Icon({
        size: new this.AMap.Size(15, 15),
        image: require("@/assets/dw.png"),
        imageSize: new this.AMap.Size(15, 15),
        imageOffset: new this.AMap.Pixel(0, 0),
      });
      this.markerList.forEach((item, index) => {
        if (count == index) {
          item.setIcon(Icon);
        } else {
          item.setIcon(smallIcon);
        }
      });
    },
    setMarker() {
      if (!this.AMap || !this.map) return;
      this.markerList = [];
      this.map.clearMap();

      const city = this.focusData[0];
      if (!city) return;
      const position = new this.AMap.LngLat(city.longitude, city.latitude);
      this.map.setCenter(position);
      this.map.setZoom(11);

      this.focusData.forEach((item) => {
        const endIcon = new this.AMap.Icon({
          size: new this.AMap.Size(15, 15),
          image: require("@/assets/dw.png"),
          imageSize: new this.AMap.Size(15, 15),
          imageOffset: new this.AMap.Pixel(0, 0),
        });
        const marker = new this.AMap.Marker({
          position: new this.AMap.LngLat(item.longitude, item.latitude),
          icon: endIcon,
          offset: new this.AMap.Pixel(-13, -30),
        });
        marker.setExtData(item.years)
        marker.on('click',(e)=>{
          this.markerHandler(e)
        })
        this.markerList.push(marker);
      });
      this.map.add(this.markerList);
    },
    getIndicatorTrend() {
      this.$http.getFocusData({ cubeId: this.cubeId }).then((res) => {
        if (res.success) {
          const years = [];
          this.tabData = res.focusTransferData;
          console.log(this.tabData)
          res.years.forEach((item, index) => {
            if (item % 2 != 0) {
              years.push({ val: item, key: index });
            }
          });
          this.yearList = years;
          this.focusData = res.focusData;
          if (this.map) {
            this.setMarker();
          }
        }
      });
    },
    initMap() {
      AMapLoader.load({
        key: "e39037764d5c2ca2e2fc07a5c3505bc7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.PolygonEditor",
          "AMap.Marker",
          "AMap.PlaceSearch",
        ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("container", {
            //设置地图容器id
            zoom: 8, //初始化地图级别
            center: [116.602725, 40.076636], //初始化地图中心点位置
          });

          //比例尺
          let scale = new AMap.Scale({
            position: {
              bottom: "10px",
              right: "50px",
            },
          });
          //放大缩小工具
          let toolBar = new AMap.ToolBar({
            visible: true,
            position: {
              bottom: "10px",
              right: "10px",
            },
          });
          //信息描述框
          infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(20, -30),
          });

          //设置标记点
          this.setMarker();
          this.map.addControl(scale);
          this.map.addControl(toolBar);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  beforeDestroy() {
    clearInterval(timer);
    timer = null;
  },
  watch: {
    cubeId(val) {
      this.getIndicatorTrend();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";

table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  border-collapse: unset;
  // border-top: 1px solid #000;
  // border-right: 1px solid #000;
  th,
  td {
    // border-left: 1px solid #000;
    border-bottom: 1px solid #E8E8E8;
  }
  td {
    height: 54px;
    color: #000;
    padding: 3px 5px;
    font-size: 14px;
  }
  .alignCenter {
    text-align: center;
  }
  .tab-weight{
    font-weight: 600;
    background:#FAFAFA
  }
  .active {
    background: #FAFAFA;
  }
}

</style>
<style lang="scss">
.amap-info{
  width: 225px;
  .amap-info-content{
    width: 225px;
    font-size: 14px;
  }
  .amap-info-sharp{
    left:40%;
  }
}
</style>
